package com.xtream.data_kmp.dto


import androidx.room3.ColumnInfo
import androidx.room3.Embedded
import androidx.room3.Entity
import androidx.room3.PrimaryKey
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock


@Serializable
abstract class CategoryBase {
    abstract val categoryId: Int?
    abstract val categoryName: String?
    abstract val parentId: Int?
    abstract val createdAt:Long
}


const val liveCategoriesTable="liveCategoriesTable"

@Serializable
@Entity(liveCategoriesTable)

data class LiveCategory(

    @SerialName("category_id")
    @PrimaryKey
    override val categoryId: Int?,

    @SerialName("category_name")
    override val categoryName: String?=null,

    @SerialName("parent_id")
    override val parentId: Int?=null,

    @ColumnInfo(name = "created_at", index = true)
    override val createdAt: Long=  Clock.System.now().toEpochMilliseconds()
    ): CategoryBase()

const val vodCategoriesTable="vodCategoriesTable"
@Serializable
@Entity(tableName =vodCategoriesTable )

data class VodCategory(

    @SerialName("category_id")
    @PrimaryKey
    override val categoryId: Int,

    @SerialName("category_name")
    override val categoryName: String?,

    @SerialName("parent_id")
    override val parentId: Int?=null,
    @ColumnInfo(name = "created_at", index = true)
    override val createdAt: Long=  Clock.System.now().toEpochMilliseconds()
    ): CategoryBase()

const val seriesCategoriesTable="seriesCategoriesTable"

@Serializable
@Entity(seriesCategoriesTable)

data class SeriesCategory(

    @SerialName("category_id")
    @PrimaryKey
    override val categoryId: Int?,

    @SerialName("category_name")
    override val categoryName: String?=null,

    @SerialName("parent_id")
    override val parentId: Int?=null,

    @ColumnInfo(name = "created_at", index = true)
    override val createdAt: Long=  Clock.System.now().toEpochMilliseconds()
    ): CategoryBase()


interface  CategoryWithSize<T:CategoryBase> {
   val category: T
   val size:Int
}

data class LiveCategoryWithSize( @Embedded override val category: LiveCategory, override val size: Int):CategoryWithSize<LiveCategory>

data class VodCategoryWithSize( @Embedded override val category: VodCategory, override val size: Int):CategoryWithSize<VodCategory>

data class SeriesCategoryWithSize( @Embedded override val category: SeriesCategory, override val size: Int):CategoryWithSize<SeriesCategory>


data class CategoryWithStream<S:Any,C:CategoryBase>(
    val streams: List<S>,
    override val category: C,
    override val size: Int
):CategoryWithSize<C>

